import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionTag from "@/components/SectionTag";

export default function JeremyPreview() {
  return (
    <section data-testid="jeremy-preview-section" className="bg-brand-navy">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 md:py-28 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative mx-auto max-w-sm lg:mx-0">
              <div className="absolute -inset-3 -rotate-2 rounded-[2.5rem] border border-white/15" />
              <div className="absolute -inset-3 rotate-1 rounded-[2.5rem] bg-brand-red/15" />
              <img
                src="/images/jeremy-headshot.png"
                alt="Jeremy Pene, FNP-C, provider at Advantage Primary Health"
                data-testid="jeremy-preview-image"
                className="relative aspect-[4/5] w-full rounded-[2rem] object-cover shadow-lift"
              />
              <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand-red px-6 py-2.5 shadow-red">
                <p className="text-xs font-semibold text-white">
                  20+ Years of Clinical Experience
                </p>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal>
            <SectionTag number="03" label="Your Provider" light />
            <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
              Meet Jeremy Pene,{" "}
              <span className="font-serif italic text-brand-red">FNP-C</span>
            </h2>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
              With more than 20 years of experience in acute and emergency
              care, Jeremy Pene, FNP-C brings exceptional clinical expertise and
              a personal approach to every patient relationship. As part of a
              military family-owned and operated practice, Jeremy believes
              family, compassion, and truly listening should always come first.
            </p>
            <Link
              to="/meet-jeremy"
              data-testid="jeremy-preview-meet-btn"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-brand-navy transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-slate-100"
            >
              Meet Jeremy
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
